import { SetupContext } from '@vue/composition-api'
import { FormModel } from '@/types/form.types'
import { scrollTo } from '@/utils/window.utils'
import { ErrorObject } from '@vuelidate/core'
import { email } from '@vuelidate/validators'
import { MAX_DEFAULT_ATTACHMENT_SIZE } from '@/constants/file-picker'

const SWEDISH_ALPHABETIC_REGEX = /^[a-zA-ZäöåÄÖÅ ]+$/
const PHONE_NUMBER_REGEX = /^(\+\d{3,})$/
const SWEDISH_PHONE_NUMBER_REGEX = /^(\+46\d{5,11})$/
const SWEDISH_PERSONAL_IDENTITY_NUMBER_PATTERN = /^(19|20)\d{10}$/

export enum ValidationState {
  Invalid = 'Invalid',
  Valid = 'Valid'
}

export const emailValidator = (value: string) => email.$validator(value.toLowerCase())
export const phoneNumberValidator = (value: string) => !value || PHONE_NUMBER_REGEX.test(value)
export const swedishPhoneNumberValidator = (value: string) => !value || SWEDISH_PHONE_NUMBER_REGEX.test(value)
export const swedishCharactersValidator = (value: string) => !value || SWEDISH_ALPHABETIC_REGEX.test(value)
export const swedishPersonalIdentityNumberValidator = (value: string) => !value || SWEDISH_PERSONAL_IDENTITY_NUMBER_PATTERN.test(value)
export const attachmentSizeValidator = (limit: number = MAX_DEFAULT_ATTACHMENT_SIZE) => (files: File[]) => {
  if (files.length) {
    const fileSizeSum = files.reduce((total: number, file: File) => total + file.size, 0)
    return fileSizeSum <= limit
  }
  return true
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getValidationState = (field: any): ValidationState => {
  return field.$invalid && field.$dirty ? ValidationState.Invalid : ValidationState.Valid
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getValidationMessage = (field: any, message: string): string => {
  return getValidationState(field) === ValidationState.Valid ? '' : message
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const scrollToInvalidField = (formModel: FormModel<any>, context: SetupContext, formName: string) => {
  const formRef = context.refs[formName] as Vue
  const failingFieldKey = formModel.$v.value.$errors[0].$property
  const failingFieldRef: Vue = formRef.$refs[failingFieldKey] as Vue
  const failingFieldElement = failingFieldRef.$el as HTMLElement
  scrollTo(failingFieldElement.offsetTop)
}

export const scrollToInvalidFieldV2 = (context: SetupContext, formErrors: ErrorObject[]) => {
  const firstFailingInputRefName = `${formErrors[0].$property}Ref`
  const firstFailingInputRef = context.refs[firstFailingInputRefName] as Vue
  const firstFailingInputElement = firstFailingInputRef.$el as HTMLElement

  scrollTo(firstFailingInputElement.offsetTop)
}
